var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Controller } from "react-hook-form";
import { AfyButton, AfyInput, AfyModal, } from "@affinitysystemsgroup/assurehub-ui";
import { REJECTION_CODES_TEXT } from "../../../constants/rejectionCodes.constants";
import { useRenameSetModal } from "../hook/renameSetModal.hook";
import { RenameSetModalFooter, RenameSetModalForm, RenameSetModalTitle, } from "../style/renameSetModal.style";
export var RenameSetModalView = function (props) {
    var p = useRenameSetModal(props);
    return (_jsx(AfyModal, __assign({ opened: props.opened, onClose: props.onClose, title: _jsx(RenameSetModalTitle, { children: REJECTION_CODES_TEXT.renameModalTitle }), size: "sm" }, { children: _jsxs(RenameSetModalForm, __assign({ noValidate: true, onSubmit: p.onSubmit }, { children: [_jsx(Controller, { name: "name", control: p.control, rules: { required: REJECTION_CODES_TEXT.nameRequiredError }, render: function (_a) {
                        var _b;
                        var field = _a.field, fieldState = _a.fieldState;
                        return (_jsx(AfyInput, { value: field.value, onChange: field.onChange, onBlur: field.onBlur, label: REJECTION_CODES_TEXT.renameNameLabel, error: (_b = fieldState.error) === null || _b === void 0 ? void 0 : _b.message }));
                    } }), _jsxs(RenameSetModalFooter, { children: [_jsx(AfyButton, { label: REJECTION_CODES_TEXT.cancelButton, variant: "default", onClick: props.onClose }), _jsx(AfyButton, { label: REJECTION_CODES_TEXT.saveButton, type: "submit", variant: "filled", color: "brand" })] })] })) })));
};
